import { render } from "./CreateAppointmentHour.vue?vue&type=template&id=6c6c3647&scoped=true"
import script from "./CreateAppointmentHour.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentHour.vue?vue&type=script&lang=js"

import "./CreateAppointmentHour.vue?vue&type=style&index=0&id=6c6c3647&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6c3647"]])

export default __exports__